<app-store-navigation></app-store-navigation>
@if (date && hours) {
  <div>
    <app-rota-day-select
      [weekId]="currentWeekId"
      [date]="date">
    </app-rota-day-select>
    <div class="alert alert-info" role="alert">
      @for (managerSettings of canDoSalesByEmployee | keyvalue; track managerSettings) {
        <span>
          {{ managerSettings.key.role | enumParse }} {{ managerSettings.key.name }} is@if (!managerSettings.value) {
          <span> not</span>
          } a salesperson.
        </span>
      }
    </div>
    <div class="hours">
      <div class="total-working-hours-box">
        <div class="total-working-hours-text">Total: {{ getTotalHoursFormatted() }}</div>
      </div>
      @for (hour of hours; track hour) {
        <div class="hour-box" [style.width.px]="cellWidth">
          @if (hour !== hours[0] && hour !== hours[hours.length - 1]) {
            <div class="hour-text">
              {{ hour | timeParse | dateFormat: 'HH:mm' }}
            </div>
          }
        </div>
      }
    </div>
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td>Footfall /<br>Recommended employee</td>
          @for (hour of hours; track hour) {
            <td [style.width.px]="cellWidth">
              <app-rota-day-employee-capacity
                [hour]="hour"
                [employeeCapacityList]="employeeCapacityList">
              </app-rota-day-employee-capacity>
            </td>
          }
        </tr>
        @for (employee of employees; track employee) {
          <tr>
            <td>
              <div class="employee-name">
                <a routerLink="/employees/{{store.slug}}/{{employee.employeePositionId.parseEmployeeId()}}/{{employee.employeePositionId.parsePositionId()}}">{{ employee.name }}</a>
              </div>
              <app-rota-day-availability
                [dayOfWeek]="dayOfWeek"
                [employeePositionId]="employee.employeePositionId">
              </app-rota-day-availability>
              <app-rota-day-work-day
                [dayOfWeek]="dayOfWeek"
                [employee]="employee"
                [gridStartHour]="hours[0]"
                [cellWidth]="cellWidth">
              </app-rota-day-work-day>
              <app-rota-day-unavailable
                [employeePositionId]="employee.employeePositionId"
                [dayOfWeek]="dayOfWeek"
                [hours]="hours"
                [cellWidth]="cellWidth">
              </app-rota-day-unavailable>
            </td>
            @for (hour of hours; track hour) {
              <td
              [ngClass]="{'undercapacity-background': isUnderStaffedAt(hour), 'overcapacity-background': isOverStaffedAt(hour)}"></td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
